import React from 'react';
import { shallowEqual } from 'react-redux';
import conf from '../../../../../classes/configController';
import { useAppSelector } from '../../../../../hooks/hooks';
import useContext from '../../../../../hooks/useContext';
import propsStore from '../../../../../store/propsStore/propsStore';
import { DataGridIdentifier } from './context';
import HeaderCell from './HeaderCell';
import { noNaN } from '../../../../../utils/util';
import { arrayOrArray } from '@apia/util';

const Header = () => {
  const { gridId } = useContext(DataGridIdentifier);
  const {
    columns,
    grid,
    isSomeDeleteShown,
    isSomeEditFormShown,
    shouldHideDeleteButton,
  } = useAppSelector((global) => {
    const state = global.dataGridSlice[gridId];
    const grid = state.context.grid.field;
    const props = propsStore.getFieldProps(gridId);

    const startIndexInner = noNaN(grid.startIndex);

    let isSomeEditFormShownInner = false;
    for (
      let i = startIndexInner;
      i < state.rows.length + startIndexInner;
      i++
    ) {
      if (state.showEditFormButtons[i] !== false) {
        isSomeEditFormShownInner = true;
        break;
      }
    }

    return {
      grid: grid,
      columns: state.columns,
      shouldHideDeleteButton:
        String(
          grid.properties.hideIncludeButton ||
            grid.properties.hideDelButton ||
            grid.properties.hideGridButtons ||
            state.context.form.isFormReadOnly ||
            props?.readonly,
        ) === 'true' || grid.properties.gridQuery,
      isSomeDeleteShown: state.showDeleteButtonsCount > 0,
      isSomeEditFormShown:
        !!grid.properties.gridForm && isSomeEditFormShownInner,
    };
  }, shallowEqual);

  const isDeleteButtonVisible =
    !shouldHideDeleteButton &&
    conf('execution.components.dataGrid.showDeleteButton', false);

  return (
    <thead className="grid__header">
      <tr data-focusindex={1}>
        {(isSomeEditFormShown ||
          isDeleteButtonVisible ||
          isSomeDeleteShown) && (
          <th
            className="grid__header__cell disabled"
            style={{ color: 'transparent' }}
          >
            .
          </th>
        )}
        {columns.map((column, columnIndex) => {
          const field = arrayOrArray(grid.field)[columnIndex];
          return (
            <HeaderCell
              key={column.id}
              columnIndex={columnIndex}
              column={{
                ...column,
                isHidden:
                  field?.properties?.visibilityHidden ||
                  field?.fieldType === 'hidden',
              }}
            />
          );
        })}
      </tr>
    </thead>
  );
};

export default React.memo(Header);
